const mergeClassNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

export default mergeClassNames;
